import "./style.css";

import * as bootstrap from 'bootstrap'


let selectedIndex1 =0;
let selectedIndex2 = 0;
let timeout = null;

const disc1 = document.getElementById("disc1");
const disc2 = document.getElementById("disc2");
const sentence = document.getElementById("sentences"); 
const parts1 = Array.from(disc1.children); 
const parts2 = Array.from(disc2.children); 
const sentences = Array.from(sentence.children ); 
const modal =  new bootstrap.Modal(document.getElementById('modal'))





function resetOpacity() {
  [...parts1, ...parts2].forEach(el => el.style.opacity = "1");
}




function highlightSelectedParts() {
  sentences.forEach(el => el.style.display = "none");
document.getElementById("div-d1-"+selectedIndex1+"-d2-"+selectedIndex2).style.display = "block"


  parts1.forEach((el, i) => el.style.opacity = i === selectedIndex1 ? "1" : "0.1");
  parts2.forEach((el, i) => el.style.opacity = i === selectedIndex2 ? "1" : "0.1");

  setTimeout(() => {
    modal.show()
  }, 2000);



}




function rotateDisc1(num) {
    resetOpacity();
        clearTimeout(timeout);

  var spin = 360 * (2 + Math.floor(Math.random() * 2))

  var current = disc1.style.transform ||
         "rotate(0deg)";




var currentValue = current.split('(')[1];
   currentValue = currentValue.split('deg)')[0];






  var rotation =   Number(currentValue) + selectedIndex1*90 - (num*90+ spin);

   disc1.style.transform = `rotate(${rotation }deg)`;


     selectedIndex1 = num; 

  timeout = setTimeout(() => {
  highlightSelectedParts()
}, 3500);



}
function rotateDisc2(num) {
    resetOpacity();
      clearTimeout(timeout);




  var spin = 360 * (2 + Math.floor(Math.random() * 2))

  var current = disc2.style.transform ||
         "rotate(0deg)";




var currentValue = current.split('(')[1];
   currentValue = currentValue.split('deg)')[0];




  var rotation =   Number(currentValue) - selectedIndex2*120 + (num*120+ spin);




   disc2.style.transform = `rotate(${rotation }deg)`;


     selectedIndex2 = num; 


  timeout = setTimeout(() => {
  highlightSelectedParts()
}, 3500);
}

function spinWheel() {

rotateDisc1(Math.floor(Math.random()*4))
rotateDisc2(Math.floor(Math.random()*3))
  

  

}

// Spin button
document.getElementById("button").addEventListener("click", spinWheel);







